import {isDebug, isFunc} from "./commonUtils";
import numeral from "numeral";
import {KAIZEN_IUL_STRATEGY, NF_IUL_STRATEGY, stateDropDown, StrategySlugEnum} from "../constants";
import {getEmployerAndParticipantCont} from "../pages/client/Enrollment/EnrollmentHome/EnrollmentApplication/Utilities";


export const Global = {
    data:{},
    set:function (key, val :any){
        this.data[key] = val
    },
    get:function (key){
        return this.data[key]
    },
    clear:function (){
        this.data= {}
    }
}
/**
 * Get strategy details for user
 * @param user
 */
export const getStrategyDetails = (user) => {
    const roleArr = [1, 2, 3, 4, 15];
    let registrationMark: boolean | undefined = true;
    let strategyName: any = "Kai-Zen";
    let strategySlug: string = "kaizen";
    const { client, accessType, role } = user;
    const clientPolicy = client && client.clientPolicies && client.clientPolicies.length > 0 && client.clientPolicies[0];
    if (client) {
        strategyName = (clientPolicy.strategy && clientPolicy.strategy.name) || strategyName;
        strategySlug = (clientPolicy.strategy && clientPolicy.strategy.slug) || strategySlug;
        registrationMark = clientPolicy.strategy && clientPolicy.strategy.registrationMark;
    } else if (accessType === "client" && roleArr.indexOf(role) !== -1) {
        strategyName = (user.demoStrategy && user.demoStrategy.name) || strategyName;
        strategySlug = (user.demoStrategy && user.demoStrategy.slug) || strategySlug;
        registrationMark = user.demoStrategy && user.demoStrategy.registrationMark;
    }
    return {strategyName, strategySlug, registrationMark};
}

export const getContributionFrequencyText = (frequency: string, capitalize: boolean = false) => {
    let frequencyText = (frequency === "Monthly" ? "monthly": "annual");
    return capitalize ? frequencyText[0].toUpperCase() + frequencyText.substring(1) : frequencyText;
}

/**
 * Repeated calls a function after given time for given number of times
 * @param func
 * @param time
 * @param repetitions
 * @param afterLastCall
 */
export function repeatCaller(func: Function, time: number, repetitions: number = 2, afterLastCall?: Function) {
    const callBack = () => {
        afterLastCall && isFunc(afterLastCall) && afterLastCall();
    };
    return () => {
        let called = 1;
        // first call
        func();
        // check min repetitions
        if (repetitions < 2) {
            callBack();
        }

        // setting interval
        let interval = setInterval(() => {
            // making repeat call
            func();
            // incrementing how many times we called
            called++;
            // check exit condition
            if (called === repetitions) {
                // clear
                clearInterval(interval);
                // callback
                callBack();
            }
        }, time);
    };
}


export function imoAgentClient(account:any)  {
    const user: any = account.user;
    const clientPolicy = user && user.client && user.client.clientPolicies && user.client.clientPolicies.length > 0 && user.client.clientPolicies[0];
    let deathBenefit: string = user ? numeral(clientPolicy && clientPolicy.deathBenefit).format("$0,0") : numeral(account.deathBenefit).format("$0,0");
    let annualPremium: string = clientPolicy ? numeral(clientPolicy && clientPolicy.annualPremium).format("$0,0") : "N/A";
    let contributionValue = clientPolicy && clientPolicy.contributionAmount;
    let contributionAmount: string = user ? numeral(contributionValue).format("$0,0") : "N/A";
    let contributionBreakUp: any = getEmployerAndParticipantCont(contributionValue, 50 , 15000);
    let employerContribution: string = user ? numeral(contributionBreakUp && contributionBreakUp.employer).format("$0,0") : "N/A";
    let participantContribution: string = user ? numeral(contributionBreakUp && contributionBreakUp.participant).format("$0,0") : "N/A";
    let trancheNumber: string = (user && user.client && user.client.tranche) ? user.client.tranche.trancheNumber : "N/A";
}


/**
 * Returns true for non-financed IUL
 * @param strategyId
 * @param strategySlug
 */
export const isNfIulCase = (strategyId: number, strategySlug: string) => {
    return strategyId === NF_IUL_STRATEGY && strategySlug === StrategySlugEnum.NfIUL;
}
/**
 * Returns true for Kaizen IUL
 * @param strategyId
 */
export const isKaiZenIulCase = (strategyId: number) => {
    return strategyId === KAIZEN_IUL_STRATEGY;
}

/**
 * Returns Value (Short Name) of State from StateDropDown
 * @param stateCode
 */
export const getStateShortNameByStateName = (stateCode: string) => {
    const stateOption = stateDropDown.find(x => x.name === stateCode);
    return stateOption && stateOption.value ? stateOption.value : stateCode;
}

type IRType = { allocationname: string; allocationrate: number; allocationweight: number };
type LabWeightType = {label: any;weight: number;};
type GAFSRType = (allocationQuestion: any, estimatedDetails: { stressRequest: any }) => (LabWeightType[]);
export const getAllocationFromStressRequest: GAFSRType = (allocationQuestion, estimatedDetails) => {
    const debugMode = isDebug();
    const stressRequest = JSON.parse(estimatedDetails.stressRequest);
    if (stressRequest && stressRequest.illustration && stressRequest.illustration.interestrates && stressRequest.illustration.interestrates[0] && stressRequest.illustration.interestrates[0].allocations) {
        const interestRateAllocations = stressRequest.illustration.interestrates[0].allocations || [];
        debugMode && console.log(interestRateAllocations, "=== stressRequest.illustration.interestrates[0].allocations");
        return (
            interestRateAllocations.map((ir: IRType) => {
                debugMode && console.info(allocationQuestion, "=== allocationQuestion");
                debugMode && console.info(ir, "=== allocationname, allocationweight");
                const aq = allocationQuestion[ir.allocationname];
                debugMode && console.log(aq, "=== allocationQuestion[allocationname]");
                const dummyWeight = (100 / interestRateAllocations.length);
                debugMode && console.info({dummyWeight})
                return {
                    label: (aq && aq.label) || `Unknown ${ir.allocationname}`,
                    weight: ir.allocationweight || dummyWeight
                }
            })
        );
    }
    return [];
};
